export const ABOUT = {
  title: 'About Ayodhya',
  subtitle: 'The Sacred City of Lord Shri Ram',
  image: '/images/design/hero-ram-mandir.webp',
  imageAlt: 'Shri Ram Janmabhoomi Mandir, Ayodhya',
  paragraphs: [
    'Ayodhya is one of the seven most sacred cities in India and the birthplace of Lord Shri Ram. Set on the banks of the River Saryu in Uttar Pradesh, it has been a centre of faith, devotion and culture for thousands of years.',
    'The city is celebrated in the Ramayana of Maharishi Valmiki, in the Skanda Purana and in Tulsidas’s Ramcharitmanas. As the capital of the ancient kingdom of Kosala and seat of the Ikshvaku dynasty, Ayodhya was known as a city that could not be conquered — a-yodhya.',
    'Today Ayodhya is a living pilgrimage city. The Shri Ram Janmabhoomi Mandir, consecrated on 22 January 2024, stands beside centuries-old shrines like Hanuman Garhi and Kanak Bhawan, while the ghats of the Saryu glow each evening with aarti and diyas.',
  ],
  features: [
    { icon: 'landmark', title: 'Ancient Heritage', body: 'Thousands of years of recorded history and living tradition' },
    { icon: 'om', title: 'Spiritual Significance', body: 'Janmabhoomi of Lord Ram and a Moksha-puri' },
    { icon: 'sparkles', title: 'Cultural Richness', body: 'Ram Leela, Deepotsav, classical music and Awadhi cuisine' },
  ],
  stats: [
    { value: '2500+', label: 'Years of History' },
    { value: '100+', label: 'Sacred Temples' },
    { value: '7', label: 'Holy Ghats' },
    { value: '1', label: 'Divine City' },
  ],
  highlights: [
    { title: 'Shri Ram Janmabhoomi Mandir', body: 'The grand Nagara-style temple at the birthplace of Lord Ram, built in pink Bansi Paharpur sandstone.', image: '/images/design/hero-ram-mandir.webp', to: '/temples' },
    { title: 'Hanuman Garhi', body: 'A 10th-century hilltop fort-temple where devotees seek Hanuman ji’s blessings before Ram darshan.', image: '/images/hanuman/temple-1.webp', to: '/temples' },
    { title: 'Ghats of the Saryu', body: 'Ram ki Paidi, Guptar Ghat and Lakshman Ghat — sunrise dips and sunset aartis.', image: '/images/ghats/saryu-ghat-1.jpeg', to: '/ghats' },
  ],
};
